// Module
var code = "<a class=\"ccs-link grey-link\" uib-popover-template=\"{{infoTemplate}}\" popover-trigger=\"outsideClick\" popover-placement=\"left\" popover-is-open=\"isOpen\"> <span class=\"glyphicon glyphicon-question-sign\"></span> </a> ";
// Exports
module.exports = code;